import { AsyncPipe, NgIf } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatDivider } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CALL_BACK_ICON, GOOGLE_SHEET_ICON } from '../../../../app.component';
import { GoogleSheetsIntegrationResponse } from '../../../../models/responses/google-sheets-integration-response';
import { AiAgentResponse } from '../../../../models/responses/ai-agent-response';
import { AiConfigurationPageEventsService } from '../../../../events/ai-configuration-page-events.service';
import { FormEntriesComponent } from '../form-entries/form-entries.component';
import { GoogleSheetIntegrationService } from '../../../../services/google-sheet-integration.service';
import { FormEntryResponse } from '../../../../models/responses/form-entry-response';
import { MatSnackBar } from '@angular/material/snack-bar';
import { handleErrors } from '../../../../utilities/error-handler-utils';
import { CreateGoogleSheetIntegrationRequest } from '../../../../models/requests/create-google-sheet-integration-request';

@Component({
  selector: 'app-google-sheet-dialog',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatDialogModule,
    MatDivider,
    MatIconModule,
    NgIf,
    MatAutocompleteModule,
    AsyncPipe,
    FormEntriesComponent,
    MatProgressSpinnerModule
  ],
  templateUrl: './google-sheet-dialog.component.html',
  styleUrl: './google-sheet-dialog.component.scss'
})
export class GoogleSheetDialogComponent {
  googleSheetIntegrationForm!: FormGroup;
  isEditing: boolean = false;
  isLoading: boolean = false;
  googleSheetIcon: string = GOOGLE_SHEET_ICON;
  errorMessage: string | undefined = undefined;
  constructor(
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<GoogleSheetDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { aiAgent: AiAgentResponse, googleSheetIntegration: GoogleSheetsIntegrationResponse,integrationId:number },
    private googleSheetService: GoogleSheetIntegrationService,
    private snackBar: MatSnackBar,
    private aiConfigurationPageEventService: AiConfigurationPageEventsService
  ) { }

  ngOnInit() {
    const integrationId = this.data.integrationId;

    if (integrationId) this.isEditing = true;

    this.googleSheetIntegrationForm = this.formBuilder.group({
      id: [integrationId ? integrationId : -1, Validators.required],
      sheetName:['', Validators.required]
    })
  }

  onSubmit() {
    if(this.googleSheetIntegrationForm.valid){
      this.isLoading = true;
      const request: CreateGoogleSheetIntegrationRequest = {
        aiAgentIntegrationsId:this.googleSheetIntegrationForm.value['id'] ,
        formEntries: this.getFieldsValue(),
        sheetName: this.googleSheetIntegrationForm.value['sheetName'],
      }
  
      this.googleSheetService.create(request).subscribe({
        next: (googleSheetIntegration) => {
          this.isLoading = false;
          this.snackBar.open('Google sheet integration was successful', 'Close', { duration: 5000 });
          this.aiConfigurationPageEventService.onGoogleSheetAddedEvent.emit(googleSheetIntegration);
        },
        error: (error) => {
          this.isLoading = false;
          this.errorMessage = handleErrors(error);
          if(!this.errorMessage){
            alert('server error, please contact support')
          }
        }
      })
    }
   
  }
  get fields(): FormArray<FormGroup> {
    return this.googleSheetIntegrationForm.controls['fields'] as FormArray<FormGroup>;
  }

  getFieldsValue(): FormEntryResponse[] {
    const values: FormEntryResponse[] = [];

    for (let index = 0; index < this.fields.length; index++) {
      const formGroupValue = this.fields.controls[index].value;
      const fieldId: number = parseInt(formGroupValue['id']);

      if (this.data.googleSheetIntegration) {
        values.push({
          id: isNaN(fieldId) ? undefined : fieldId,
          fieldName: formGroupValue['fieldName'],
          fieldDescription: formGroupValue['fieldDescription'],
          fieldType:formGroupValue['fieldType'],
          fieldKey: formGroupValue['fieldKey'],
          googleSheetsIntegratonId: this.data.googleSheetIntegration.id
        });
      } else {
        values.push({
          id: isNaN(fieldId) ? undefined : fieldId,
          fieldName: formGroupValue['fieldName'],
          fieldType:formGroupValue['fieldType'],
          fieldDescription: formGroupValue['fieldDescription'],
          fieldKey: formGroupValue['fieldKey']
        });
      }
    }

    return values;
  }

}
